import { Row, Modal, Button } from "react-bootstrap"
import classes from './ApplicationCard.module.css'
import ageImage from '../../../../assets/age-group.png'
import locationImage from '../../../../assets/placeholder.png'
import eduImage from '../../../../assets/magistrate.png'
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import 'moment/locale/ar'
import { authAxios } from "../../../../API/apiRequest"
import { Picker } from "../../../../components/Picker/Picker"
import { ActionMeta, SingleValue } from "react-select"
import validator from 'validator'
import { Link } from 'react-router-dom'

export interface IApplicationsCardProps{
    id: string,
    name: string,
    picture: string,
    edu: string,
    age: string,
    fromSadat: string,
    removeApplication?: (id: string)=>void,
    address?: [] | [{label: string, value: string}]
}


const ApplicationCard: React.FC<IApplicationsCardProps> = (props)=>{
    const [showReject, setShowReject] = useState(false)
    const [showAppointment, setShowAppointment] = useState(false)
    const [date, setDate] = useState<string | null>(null)
    const [addressId, setAddressId] = useState<string | undefined>(undefined)
    const [err, setErr] = useState<string>('')

    const onDone = async()=>{
        try{
            if(!addressId || !date){
                setErr('من فضلك تأخد من إدخال البيانات بشكل صحيح')
                return
            } 
            if(!validator.isAfter(new Date(date).toString())){
                setErr('من فضلك تأخد من إدخال البيانات بشكل صحيح')
                return
            }
            setShowAppointment(false)
            let result = await authAxios.post(`/employer/applications/${props.id}/accept`, {date: new Date(date), addressId},{
                headers: {
                  'Content-Type': 'application/json'
                }})
            if(result.status === 201)
                if(props.removeApplication)
                    props?.removeApplication(props.id)
        }catch(e){
            console.log(e)
        }
    }
    const onChangeDate = (e: any)=>{
        try{
            setDate(e.target.value)
            setErr('')
            console.log(e.target.value)
            if(!validator.isAfter(new Date(e.target.value).toString())){
                setErr('من فضلك تأكد من إدخال التاريخ والوقت بشكل صحيح')
            }
        }catch(e){
            console.log(e)
        }
    }
    const onCancelAppointment = ()=>{
        setShowAppointment(false)
        setDate(null)
        setAddressId(undefined)
        setErr('')
    }
    const onCancel = ()=>{
        setShowReject(false)
    }
    const onReject = async()=>{
        try{
            let result = await authAxios.post(`/employer/applications/${props.id}/reject`)
            if(result.status === 200){
                setShowReject(false)
                if(props.removeApplication)
                    props.removeApplication(props.id)
            }

        }catch(e){
            console.log(e)
        }
    }

    return(
        <Row className={classes.application}>
        <Reject onReject={onReject} onCancel={onCancel} show={showReject}  />  
        <AddAppointment 
             show={showAppointment}
             onCancel={onCancelAppointment}
             onReject={onDone}
             address={props.address}
             onChangeDate={onChangeDate}
             onSelectAddress={(a)=>setAddressId(a?.value)}
             err={err}
            />
        <Link target="_blank" rel="noopener noreferrer" to={`/employer/application/${props.id}`} className={`col-md-8 d-flex m-0 p-0 ${classes.empCol}`} >
           <div className="px-4" style={{padding: 10, width: '100%', boxSizing: 'border-box'}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
            <div className={classes.nameDiv}>
                <p style={{
                    color: '#000', 
                    marginRight: 10, 
                    textAlign: 'right',
                    fontSize: 18,
                    }}
                >
                 {props.name}
                </p>
                 <img 
                    src={props.picture}
                    alt='img' 
                    className={classes.profileImage}
                />
            </div>
            </div>
           
                 <div className='container-fluid' style={{
                     boxSizing: 'border-box'
                     }}>
                    <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: 15}}>
                    <div style={{
                         display: 'flex', 
                         flexDirection: 'row', 
                         alignItems: 'center', 
                         justifyContent: 'flex-end',
                         margin: 0,
                         padding: 0
                         }}>
                         <p dir="rtl" style={{
                             margin: 0, 
                             padding: 0, 
                             color: '#000', 
                             marginRight: 5
                             }}>
                                 {props.age}
                        </p>
                         <img src={ageImage} style={{objectFit: 'cover', width: 20, height: 20}} alt='age'></img>
                     </div>
                     <div style={{
                         display: 'flex', 
                         flexDirection: 'row', 
                         alignItems: 'center', 
                         justifyContent: 'flex-end',
                         margin: 0,
                         padding: 0
                         }}>
                         <p style={{margin: 0, padding: 0, color: '#000', marginRight: 5}}>{props.fromSadat}</p>
                         <img src={locationImage} style={{objectFit: 'cover', width: 20, height: 20}} alt='age'></img>
                     </div>
                     <div style={{
                            display: 'flex', 
                            flexDirection: 'row', 
                            alignItems: 'center', 
                            justifyContent: 'flex-end',
                            margin: 0,
                            padding: 0}}>
                            <p style={{margin: 0, padding: 0, color: '#000', marginRight: 5}}>{props.edu}</p>
                            <img src={eduImage} style={{objectFit: 'cover', width: 20, height: 20}} alt='age'></img>
                        </div>
                     
                 </Row>
                 </div>
            </div>
        </Link>
    </Row>
    )
} 


export interface IinterviewCardProps{
    id: string,
    name: string,
    date: string,
    phone: string,
    picture: string
}

export const InterviewCard: React.FC<IinterviewCardProps> = (props)=>{

    const [showAppointment, setShowAppointment] = useState(false)

    const onCancel = ()=>{
        setShowAppointment(false)
    }
    const onDone = async()=>{
        try{
            
        }catch(e){
            console.log(e)
        }
    }
    useEffect(()=>{
    },[])

    return(
        <Row className={classes.application} style={{marginBottom: 20}}>
            <AddAppointment 
             show={showAppointment}
             onCancel={onCancel}
             onReject={onDone}
            />
        <div className={`col-md-6 d-flex m-0 p-0 ${classes.empCol}`} >
           <div className="px-4" style={{padding: 10, width: '100%', boxSizing: 'border-box'}}>
            <Link target="_blank" rel="noopener noreferrer" to={`/employer/application/${props.id}`}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
            <div className={classes.nameDiv}>
                <div style={{marginRight: 10}}>
                <p style={{
                    color: '#000', 
                    margin: 0,
                    padding: 0,
                    textAlign: 'right',
                    fontSize: 18,
                    width: '100%',
                    }}
                >
                 {props.name}
                </p>
                </div>
                 <img 
                    src={props.picture}
                    alt='img' 
                    className={classes.profileImage}
                />
            </div>
            </div>
            <div style={{marginTop: 15}}>
            <p dir="rtl" style={{
                    color: '#000',
                    margin: 0,
                    textAlign: 'right',
                    fontSize: 14,
                    width: '100%',
                    padding: 0,
                    marginRight: 90
                    }}
                >
                رقم الهاتف
                </p>
            <p dir="rtl" style={{
                   textAlign: 'center', 
                   padding: 8, 
                   backgroundColor: '#fff', 
                   borderRadius: 5, 
                   fontWeight: 'bold',
                   color: '#000'
                    }}
                >
                {props.phone}
                </p>
            </div>
            <div style={{}}>
                <p dir="rtl" style={{
                        color: '#000',
                        margin: 0,
                        textAlign: 'right',
                        fontSize: 14,
                        width: '100%',
                        padding: 0,
                        marginRight: 90
                        }}
                >
                الموعد
                </p>
                <p style={{
                    textAlign: 'center', 
                    padding: 8, 
                    backgroundColor: '#fff', 
                    borderRadius: 5, 
                    fontWeight: 'bold',
                    color: '#000'

                }}>
                    {moment(new Date(props.date)).format('h:mm a, Do MMMM YYYY')}
                </p>
            </div>
        </Link>
        </div>
        </div>
        </Row>
    )
}


interface IModalComponentProps{
    show: boolean,
    accept: ()=>void,
    reject: ()=>void,
    setShow?: ()=>void,
    title?: string,
    variant?: string
}


export const ModalComponent: React.FC<IModalComponentProps> = (props)=>{


    return(
        
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.reject}
            show={props.show}
        >
            <Modal.Header style={{flexDirection: 'row-reverse'}}>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title && props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
               {props.children}
            </Modal.Body>
            <Modal.Footer style={{justifyContent: 'flex-start'}}>
                <Button onClick={props.accept} variant={props.variant ? props.variant : "danger"}>موافق</Button>
                <Button onClick={props.reject}>إلغاء</Button>
            </Modal.Footer>
        </Modal>
    )
}



interface IRejectProps{
    onReject: ()=>void,
    onCancel: ()=>void,
    show: boolean,
    setShow?: ()=>void,
    address?: [] | [{label: string, value: string}],
    onChangeDate?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
    onSelectAddress?: ((newValue: SingleValue<{
        label: string;
        value: string;
    }>, actionMeta: ActionMeta<{
        label: string;
        value: string;
    }>) => void) | undefined,
    err?: string,
}

export const Reject: React.FC<IRejectProps> = (props)=>{

     
    return(
        <ModalComponent
         show={props.show}
         accept={()=>props.onReject()}
         reject={()=>props.onCancel()}
         title='تأكيد الرفض'
        >
             <h5 style={{textAlign: 'right'}}>هل ترغب في رفض هذا الطلب؟</h5>
        </ModalComponent>
    )
}
export const UnReject: React.FC<IRejectProps> = (props)=>{

     
    return(
        <ModalComponent
         show={props.show}
         accept={()=>props.onReject()}
         reject={()=>props.onCancel()}
         title='تأكيد إلغاء الرفض'
        >
             <h5 style={{textAlign: 'right'}}>هل ترغب في إلغاء الرفض لهذا الطلب؟</h5>
        </ModalComponent>
    )
}

export const AddAppointment: React.FC<IRejectProps> = (props)=>{

   
    return(
        <ModalComponent
        show={props.show}
        accept={()=>props.onReject()}
        reject={()=>props.onCancel()}
        title='تحديد موعد'
        variant="success"
       >
            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flexDirection: 'column'}}>
                <p dir='rtl'>الموعد: </p>
                <input 
                  type="datetime-local"
                  style={{borderRadius: 5, backgroundColor: 'rgba(0,10,10, 0.9)', padding: 10, border: 0, color: '#fff'}}
                  onChange={props.onChangeDate}
                />
            </div>
            <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flexDirection: 'column'}}>
                <p dir='rtl'>العنوان: </p>
                <Picker 
                    onChange={props.onSelectAddress}
                    color="rgba(0,10,10, 0.9)" 
                    options={props.address} 
                    placeholder='العنوان'
                />
            </div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                <p dir='rtl' style={{color: "darkred"}}>{props?.err}</p>
            </div>
       </ModalComponent>
    )
}





export default ApplicationCard